import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { cloneDeep, cloneDeepWith } from "lodash";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../../common_components/mdae-framework";
import { GET_TARGET_VALUE_LOOKUP } from "../../../services/get-taregt-values";
import { GET_STATUS_LOOKUP_LIST } from "../services/get-audit-case-finding-status";
import { GET_CASE_DATA } from "../services/get-case-data";
import { GET_CODE_TYPES_LOOKUPS } from "../../../services/get-code-types-lookups";
import { VALIDATE_UPLOADED_CHARGE_DATA } from "../services/validate-uploaded-charge-data";
export const SET_CASE_FORM_DATA = "SET_CASE_FORM_DATA";
export const RESET_CASE_FORM_DATA = "RESET_CASE_FORM_DATA";
export const UPDATE_ROUND_DATA = "UPDATE_ROUND_DATA";
export const UPDATE_CHARGES_ROUND_DATA = "UPDATE_CHARGES_ROUND_DATA";
export const SET_EXTERNAL_AUDIT_PROPERTIES = "SET_EXTERNAL_AUDIT_PROPERTIES";
export const SET_CASE_DATA_ACCORDION_SELECTED_KEYS =
  "SET_CASE_DATA_ACCORDION_SELECTED_KEYS";
export const TOGGLE_EA_CASE_DATA_WARNING_POPUP = "TOGGLE_EA_CASE_DATA_WARNING_POPUP";
export const SET_CASE_DATA_VALIDATION_MODE = "SET_CASE_DATA_VALIDATION_MODE";
export const SET_RECORD_SUBMISSION_METHOD_DATA = "SET_RECORD_SUBMISSION_METHOD_DATA";
export const SET_CASE_PROPERTIES_DATA = "SET_CASE_PROPERTIES_DATA";
export const SET_TARGET_TYPE_VALUE_DATA_SOURCE = "SET_TARGET_TYPE_VALUE_DATA_SOURCE";
export const SET_TARGET_TYPE_SELECTION = "SET_TARGET_TYPE_SELECTION";
export const SET_TARGET_TYPES_LOOKUP = "SET_TARGET_TYPES_LOOKUP";
export const SET_IS_SET_TARGET_CODE_VALUES = "SET_IS_SET_TARGET_CODE_VALUES";
export const SET_RISK_AMOUNT_ALERT_STATUS ="SET_RISK_AMOUNT_ALERT_STATUS";
export const SET_TARGET_CHARGES_GRID_CHECKBOXES="SET_TARGET_CHARGES_GRID_CHECKBOXES";
export const TOGGLE_BULK_EDIT_TARGET_CHARGES_POPUP="TOGGLE_BULK_EDIT_TARGET_CHARGES_POPUP";
export const SET_BULK_UPDATE_DATA="SET_BULK_UPDATE_DATA";
export const TOGGLE_UPLOAD_DOCUMENT_TARGET_CHARGES_POPUP="TOGGLE_UPLOAD_DOCUMENT_TARGET_CHARGES_POPUP";
export const SET_UPLOADED_CHARGE_DATA="SET_UPLOADED_CHARGE_DATA";
export const TOGGLE_IMPORT_POPUP="TOGGLE_IMPORT_POPUP";
export const SET_TARGET_TYPE_VALUE_LIST="SET_TARGET_TYPE_VALUE_LIST";
export const SET_CURRENT_IMPORT_ROUND_DATA="SET_CURRENT_IMPORT_ROUND_DATA";
export const SET_LINE_CELL_CLICKED="SET_LINE_CELL_CLICKED";
export const SET_ROUND_DATA_SELECTED_TAB="SET_ROUND_DATA_SELECTED_TAB";
export const SET_FROM_IMPORT_TYPE="SET_FROM_IMPORT_TYPE";
export const defaultTargetChargesGridSelection = {
  mode: "single",
  showCheckBoxesMode: "always",
  selectAllMode: "allPages",
};

export const defaultCaseData = {
  payerCaseId: "",
  atRiskAmnt: 0,
  reviewRemainingAmnt: 0,
  statusId: 0,
  totalRetainedAmnt: 0,
  totalRefundAmnt: 0,
  totalRevenueLoss: 0,
  caseFinalOutcomeId: null,
  manualRefundRequired: false,
  refundSubmittedDate: null,
  refundCompletedDate: null,
  roundData: [],
  caseNotes: "",
  eaCaseId: null,
  denialReasonCode: "",
  previousCaseFinalOutcomeId: null,
  additionalReimbursementAmnt: 0,
  caseTargetType1: null,
  caseTargetValue1: null,
  caseTargetType2: null,
  caseTargetValue2: null,
  caseTargetRationaleValue:null,
  claimTypeCd: null,
  auditGroupId: null,
  uploadedChargeData:[]
};

export const defaultExternalAuditProperties = {
  eaProcessTemplateName: "",
  requesterName: "",
  referenceId: "",
  rqstrContactName: "",
  rqstrContactPhoneNumber: "",
  rqstrContactEmail: "",
  rqstrRecordSubmissionMethod: "",
  rqstrNotes: "",
  isAtRiskPayerEnabled:false,
};
export const defaultCaseDataWarningPopupData = {
  hasRoundDeterminationDate: false,
  hasActualSubmissionDate: false,
  hasRoundOutcome: false,
  hasCaseStatus: false,
  hasStartDate: false,
}
export const defaultBulkUpdateData={
targetType:'',
targetValue:'',
denialReason:'',
roundOutcome:-1,
targetRationale:-1
}

export const OutcomeTypes={
  Approved:'AP',
  DeniedWillAppeal:'DWA',
  DeniedWillNotAppeal:'DWNA',
  DeniedFinal:'DF',
}

export const caseDataValidationModes = {
  CASE_LEVEL: 'CASE_LEVEL',
  ROUND_CASE_LEVEL: 'ROUND_CASE_LEVEL',
}
const initialState = {
  isLoading: false,
  caseData: { ...defaultCaseData },
  externalAuditProperties: { ...defaultExternalAuditProperties },
  statusList: [],
  caseDataAccordionSelectedKeys: [],
  denialReasonData: [],
  eaCaseDataWarningPopupMode: null,
  isEaCaseDataWarningPopupVisible: false,
  caseDataWarningpopupData: { ...defaultCaseDataWarningPopupData },
  caseDataValidationMode: caseDataValidationModes.CASE_LEVEL,
  targetTypes: [],
  patientTypes: [],
  isSetTargetCodeValue: false,
  riskAlertVisible: false,
  targetChargesGridSelection: {},
  isBulkEditTargetChargesPopupVisible: false,
  isImportPopupVisible:false,
  bulkUpdateData: { ...defaultBulkUpdateData },
  isUploadTargetDataPopupVisible:false,
  targetTypeSelectedList:[],
  roundDataSelectedTab: {},
  isImportType:''
};
let lineLevelChargeDataGridInstance = null;

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case UPDATE_ROUND_DATA:
      const roundData = state.caseData.roundData;
      const roundItemIndex = roundData.findIndex(
        (item) => item.eaRoundId === action.data.roundId
      );
      const roundItem = cloneDeep(roundData[roundItemIndex]);
      roundItem[action.data.propName] = action.data.value;
      newState = {
        ...state,
        caseData: {
          ...state.caseData,
          roundData: [
            ...roundData.slice(0, roundItemIndex),
            roundItem,
            ...roundData.slice(roundItemIndex + 1),
          ],
        },
      };
      return newState;
    case UPDATE_CHARGES_ROUND_DATA: {
      const roundData = state.caseData.roundData;
      if (
        action.data &&
        action.data.eaRoundCaseId !== undefined &&
        Array.isArray(action.data.roundCharges)
      ) {
        const roundDataArr = roundData || [];
        const idx = roundDataArr.findIndex(
          (r) => r.eaRoundCaseId === action.data.eaRoundCaseId
        );
        if (idx !== -1) {
          let updatedRound;
          if (action.data.additionalRoundData) {
            updatedRound = {
              ...roundDataArr[idx],
              ...action.data.additionalRoundData,
              roundCharges: action.data.roundCharges,
            };
          } else {
            updatedRound = {
              ...roundDataArr[idx],
              roundCharges: action.data.roundCharges,
            };
          }
          newState = {
            ...state,
            caseData: {
              ...state.caseData,
              roundData: [
                ...roundDataArr.slice(0, idx),
                updatedRound,
                ...roundDataArr.slice(idx + 1),
              ],
            },
          };
        } else {
          newState = { ...state };
        }
      }
      return newState;
    }
    case RESET_CASE_FORM_DATA:
      return {
        ...state,
        caseData: {
          roundData: [],
        },
        caseDataAccordionSelectedKeys: [],
      };
    case SET_TARGET_CHARGES_GRID_CHECKBOXES:
      const { eaRoundCaseId, targetChargesGridSelection } = action.data;
      return {
        ...state,
        targetChargesGridSelection: {
          ...state.targetChargesGridSelection,
          [eaRoundCaseId]: targetChargesGridSelection,
        },
      };
    case TOGGLE_EA_CASE_DATA_WARNING_POPUP:
    case SET_CASE_DATA_VALIDATION_MODE:
    case TOGGLE_BULK_EDIT_TARGET_CHARGES_POPUP:
    case TOGGLE_UPLOAD_DOCUMENT_TARGET_CHARGES_POPUP:
    case SET_TARGET_TYPE_VALUE_LIST:
    case TOGGLE_IMPORT_POPUP:
    case SET_LINE_CELL_CLICKED:
    case SET_CURRENT_IMPORT_ROUND_DATA:
    case SET_FROM_IMPORT_TYPE:
    case SET_RECORD_SUBMISSION_METHOD_DATA:
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        return updateStateAfterWidgetOptionChange({ ...state }, action.data);
      } else {
        return { ...state, ...action.data };
      }
      return state;
    case SET_CASE_FORM_DATA:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const caseFormData = newState.caseData ? newState.caseData : {};
        for (let prop in action.data.caseData) {
          caseFormData[prop] = action.data.caseData[prop];
        }
        newState = { ...newState, caseData: caseFormData };
      }
      return newState;

    case SET_CASE_PROPERTIES_DATA:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const caseData = newState.caseData ? newState.caseData : {};
        for (let prop in action.data.caseData) {
          caseData[prop] = action.data.caseData[prop];
        }
        newState = { ...newState, caseData: caseData };
      }
      return newState;

    case SET_TARGET_TYPE_VALUE_DATA_SOURCE:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        if (action.currentTagetType == 1) {
          if (
            action.codeTypeValue?.toLowerCase() === "provider" &&
            newState.caseData.claimTypeCd === "P"
          ) {
            let renderingProviders = action.targetType1ValueSource.filter(
              (x) => x.isRenderingProvider == "Y"
            );
            newState = {
              ...newState,
              targetType1ValueSource: renderingProviders,
            };
          } else {
            newState = {
              ...newState,
              targetType1ValueSource: action.targetType1ValueSource,
            };
          }
        } else if (
          action.codeTypeValue?.toLowerCase() === "provider" &&
          newState.caseData.claimTypeCd === "P"
        ) {
          let renderingProviders = action.targetType2ValueSource.filter(
            (x) => x.isRenderingProvider == "Y"
          );
          newState = {
            ...newState,
            targetType2ValueSource: renderingProviders,
          };
        } else {
          newState = {
            ...newState,
            targetType2ValueSource: action.targetType2ValueSource,
          };
        }
        newState = {
          ...newState,
          targetType2ValueSource: action.targetType2ValueSource,
        };
      }
      return newState;

    case SET_TARGET_TYPE_SELECTION:
      return {
        ...state,
        targetType1Selection: action.targetType1Selection,
        targetType2Selection: action.targetType2Selection,
      };
    case SET_ROUND_DATA_SELECTED_TAB:
     return {
          ...state,
          roundDataSelectedTab: {
            ...state.roundDataSelectedTab,
            [action.data.roundId]: action.data.tabIndex,
          },
        };
    case SET_BULK_UPDATE_DATA:
      return {
        ...state,
        bulkUpdateData: {
          ...state.bulkUpdateData,
          ...action.data.bulkUpdateData
        },
      };
    case SET_TARGET_TYPES_LOOKUP:
      if (action.currentTargetType === 1) {
        return {
          ...state,
          targetTypes: action.targetTypes,
        };
      } else {
        return {
          ...state,
          targetTypes2: action.targetTypes2,
        };
      }

    case SET_IS_SET_TARGET_CODE_VALUES:
      return { ...state, isSetTargetCodeValue: action.data };
    case SET_EXTERNAL_AUDIT_PROPERTIES:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const externalAuditProperties = newState.externalAuditProperties
          ? newState.externalAuditProperties
          : {};
        for (let prop in action.data.externalAuditProperties) {
          externalAuditProperties[prop] =
            action.data.externalAuditProperties[prop];
        }
        newState = {
          ...newState,
          externalAuditProperties: externalAuditProperties,
        };
      }
      return newState;
    case SET_CASE_DATA_ACCORDION_SELECTED_KEYS:
      return { ...state, caseDataAccordionSelectedKeys: action.data.keys };
    case SET_UPLOADED_CHARGE_DATA:
      return { ...state, uploadedChargeData: action.data.uploadedChargeData };
    case SET_RISK_AMOUNT_ALERT_STATUS:
      return {
        ...state,
        riskAlertVisible: action.data.visible,
      };
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_STATUS_LOOKUP_LIST)(action)) {
        return { ...state, statusList: [] };
      }
      if (isAsyncComplete(GET_STATUS_LOOKUP_LIST)(action)) {
        const response = action.response.filter(
          (item) => item.activeInd === true
        );
        defaultCaseData.statusId = response.filter(
          (item) => item.statusType.toLowerCase() === "new"
        )[0].statusId;
        return { ...state, statusList: response };
      }
      if (isAsyncOperation(GET_CASE_DATA)(action)) {
        return {
          ...state,
          caseData: {},
          recordSubmissionMethodEnumDisplayList: [],
        };
      }
      if (isAsyncComplete(GET_CASE_DATA)(action)) {
        const response = action.response;
        return {
          ...state,
          caseData: response.caseData,
          recordSubmissionMethodEnumDisplayList:
            response.recordSubmissionMethodEnumDisplayList,
        };
      }
      if (isAsyncOperation(GET_TARGET_VALUE_LOOKUP)(action)) {
        return { ...state, denialReasonData: [] };
      }
      if (isAsyncComplete(GET_TARGET_VALUE_LOOKUP)(action)) {
        return { ...state, denialReasonData: action.response };
      }

      if (isAsyncOperation(GET_CODE_TYPES_LOOKUPS)(action)) {
        return { ...state, targetTypes: [] };
      }
      if (isAsyncComplete(GET_CODE_TYPES_LOOKUPS)(action)) {
        const response = action.response;
        return {
          ...state,
          targetTypes: response.targetTypesList,
          targetTypes2: response.targetTypesList,
          roundTargetTypes: response.targetTypesList.filter(
            (item) =>
              item.value &&
              (item.value.toLowerCase() === "cpthcpcs" ||
                item.value.toLowerCase() === "icdd" ||
                item.value.toLowerCase() === "modifier" ||
                item.value.toLowerCase() === "other")
          ),
          patientTypes: response.patientTypes,
          isSetTargetCodeValue: true,
        };
      }
      if (isAsyncOperation(VALIDATE_UPLOADED_CHARGE_DATA)(action)) {
        return { ...state,  uploadedChargeData:[]};
      }
      if (isAsyncComplete(VALIDATE_UPLOADED_CHARGE_DATA)(action)) {
        const response = action.response;
        return {
          ...state,
          uploadedChargeData:response.list
        };
      }
      return state;
    default:
      return state;
  }
}

export const formatCaseDataObject = (caseData) => {
  let caseDataObject = cloneDeep(caseData);
  const targetValue1 = caseData.caseTargetValue1?.toString();
  const targetValue2 = caseData.caseTargetValue2?.toString();
  const caseTargetRationaleValue = caseData.caseTargetRationaleValue?.toString();

  if (targetValue1?.endsWith(",")) {
    caseDataObject.caseTargetValue1 = targetValue1.slice(0, -1);
  } else {
    caseDataObject.caseTargetValue1 = targetValue1;
  }

  if (targetValue2?.endsWith(",")) {
    caseDataObject.caseTargetValue2 = targetValue2.slice(0, -1);
  } else {
    caseDataObject.caseTargetValue2 = targetValue2;
  }
  if (caseTargetRationaleValue?.endsWith(",")) {
    caseDataObject.caseTargetRationaleValue = caseTargetRationaleValue.slice(0, -1);
  } else {
    caseDataObject.caseTargetRationaleValue = caseTargetRationaleValue;
  }

  return caseDataObject;
};

export const formatFetchedCaseData = (data) => {
  if (
    data.caseTargetType1 &&
    data.caseTargetType1?.toUpperCase() !== "OTHER" &&
    data.caseTargetType1?.toUpperCase() !== "PT" &&
    data.caseTargetValue1 != ""
  ) {
    data.caseTargetValue1 = data.caseTargetValue1?.split(",");
  } else {
    data.caseTargetValue1 = data.caseTargetValue1?.toString();
  }
  if (
    data.caseTargetType2 &&
    data.caseTargetType2?.toUpperCase() !== "OTHER" &&
    data.caseTargetType2?.toUpperCase() !== "PT" &&
    data.caseTargetValue2 != ""
  ) {
    data.caseTargetValue2 = data.caseTargetValue2?.split(",");
  } else {
    data.caseTargetValue2 = data.caseTargetValue2?.toString();
  }
  if (data.caseTargetRationaleValue && data.caseTargetRationaleValue != "") {
    data.caseTargetRationaleValue = data.caseTargetRationaleValue?.split(",");
  }else{
    data.caseTargetRationaleValue = data.caseTargetRationaleValue?.toString();
  }

  if(data.roundData == null)
    data.roundData = [];
  if(data.atRiskAmnt == null)
    data.atRiskAmnt = 0;
  return data;
};

export const setLineLevelChargesDataGridInstance = (instance) => {
  lineLevelChargeDataGridInstance = instance;
};

export const getLineLevelChargesDataGridInstance = () => {
  return lineLevelChargeDataGridInstance;
};